<template>
    <div class="two-text-fields-with-symbols">
        <label v-show="toggleLabel" :for="name" v-bind:style="{fontWeight: fontWeight }">{{ label }} <span v-show="hasTooltip" class="label-tooltip rounded-circle">?</span></label>

        <div id="two-inputs">
            <div class="input-group mb-3 input-one">
                <input ref="text-field-input-one" type="text" v-model="valueOne" v-on:blur="focusOutOne" v-on:focus="saveCurrentValueOne" v-on:change="validateValueOne" class="form-control text-field-input smaller-input" :placeholder="placeholderOne" :aria-label="placeholderOne" aria-describedby="basic-addon1">
                <div class="input-group-append">
                    <span class="input-group-text symbol-smaller-input" id="basic-addon1">{{ symbolOne }}</span>
                </div>
            </div>
            <div class="input-group mb-3 input-two">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="basic-addon2">{{ symbolTwo }}</span>
                </div>
                <input ref="text-field-input-two" type="text" v-model="displayValueTwo" v-on:blur="focusOutTwo" v-on:focus="saveCurrentValueTwo" v-on:change="validateValueTwo" class="form-control text-field-input" :placeholder="placeholderTwo" :aria-label="placeholderTwo" aria-describedby="basic-addon2">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "two-text-fields-with-symbols",
        data () {
            return {
                currentValueOne: '',
                currentValueTwo: '',
                activeInputOne: false,
                activeInputTwo: false
            }
        },
        props: {
            name: String,
            valueOne: Number,
            valueTwo: Number,
            placeholderOne: String,
            placeholderTwo: String,
            label: String,
            symbolOne: String,
            symbolTwo: String,
            extraInfo: Number,
            isBoldFont: Boolean,
            hasTooltip: Boolean
        },
        computed: {
            toggleLabel: function () {
                return this.label != '';
            },
            fontWeight: function () {
                return this.isBoldFont ? 'bold' : 'normal';
            },
            displayValueTwo: {
                get: function () {
                    if (this.activeInputTwo) {
                        return this.valueTwo;
                    } else {
                        var currencyValue = this.valueTwo.toLocaleString('en-US',{useGrouping:true});
                        return currencyValue;
                    }
                },
                set: function (newValue) {
                    this.valueTwo = newValue.replace(",", "");
                }
            }
        },
        methods: {
            saveCurrentValueOne: function () {
                this.currentValueOne = this.valueOne;

                if (this.valueOne === 0) {
                    this.valueOne = '';
                }

                var valueOneLength = this.valueOne.toString().length;
                var textFieldInput = this.$refs['text-field-input-one'];
                setTimeout(function() {
                    textFieldInput.setSelectionRange(valueOneLength, valueOneLength);
                }, 0);

                this.activeInputOne = true;
            },
            saveCurrentValueTwo: function () {
                this.currentValueTwo = this.valueTwo;

                if (this.valueTwo === 0) {
                    this.valueTwo = '';
                }

                var valueTwoLength = this.valueTwo.toString().length;
                var textFieldInput = this.$refs['text-field-input-two'];
                setTimeout(function() {
                    textFieldInput.setSelectionRange(valueTwoLength, valueTwoLength);
                }, 0);

                this.activeInputTwo = true;
            },
            focusOutOne: function () {

                if (this.valueOne === '') {
                    this.valueOne = 0;
                }

                this.activeInputOne = false;
            },
            focusOutTwo: function () {

                if (this.valueTwo === '') {
                    this.valueTwo = 0;
                }

                this.activeInputTwo = false;
            },
            validateValueOne: function () {

                if (this.valueOne >= 0 && this.valueOne <= 100.00 && !isNaN(this.valueOne)) {
                    if (Math.floor(this.valueOne) !== Number(this.valueOne)) {
                        if (this.valueOne.toString().split(".")[1].length > 2) {
                            this.valueOne = Number(Math.round(Number(this.valueOne+'e'+2))+'e-'+2);
                        }
                    }
                    this.currentValueOne = this.valueOne;
                    this.$emit('calcOne', this.valueOne);
                } else {
                    this.valueOne = this.currentValueOne;
                }
            },
            validateValueTwo: function () {

                if (this.valueTwo >= 0 && !isNaN(this.valueTwo)) {
                    this.valueTwo = Math.round(this.valueTwo);

                    this.currentValueTwo = this.valueTwo;
                    this.$emit('calcTwo', this.valueTwo);
                } else {
                    this.valueTwo = this.currentValueTwo;
                }
            }
        }
    }
</script>

<style scoped>

    label {
        float: left;
        margin-right: 15px;
        font-size: 20px;
        color: #465978;
        margin-top: -7px;
    }

    #two-inputs {
        display: inline-block;
        width: 50%;
        margin-left: auto;
        float: right;
        clear: right;
    }

    .input-one {
        width: 44%;
        max-width: 75px;
        float: left;
        margin-right: 3px;
    }

    .input-two {
        width: auto;
        overflow: hidden;
    }

    .input-group-text {
        font-weight: bold;
        background-color: #fff;
        color: #465978;
        padding-left: 4px;
        padding-right: 4px;
        font-size: 18px;
    }

    .input-group-prepend, .input-group-append {
        height: 38px;
    }

    .two-text-fields-with-symbols {
        width: 85%;
        margin: 0 auto;
        overflow: hidden;
    }

    .text-field-input {
        background-color: #fff;
        text-align: right;
        font-size: 20px;
        height: 38px;
        padding-left: 5px;
        padding-right: 5px;
    }

    .input-group {
        height: 38px;
    }

    .symbol-smaller-input {
        padding-left: 4px;
        padding-right: 4px;
        border-left: 0;
    }

    .label-tooltip {
        background-color: #ee3124;
        height: 20px;
        line-height: 20px;
        width: 20px;
        padding-left: 10px;
        padding-right: 10px;
        border-radius: 50%;
        color: white;
        font-weight: bold;
    }

    .extra-info {
        color: #465978;
        font-size: 14px;
        width: 170px;
        margin-left: auto;
    }

    @media (min-width: 1024px) {
        .two-text-fields-with-symbols {
            margin-bottom: 15px;
        }
    }

    @media (max-width: 780px) {
        label {
            width: 170px;
        }
    }

    @media (max-width: 435px) {
        label {
            width: 44%;
            margin-top: -3px;
        }

        #two-inputs {
            width: 50%;
        }

        .input-one {
            width: 35%;
            margin-right: 1px;
        }

        .input-two {
            width: 64%;
        }

        .text-field-input {
            padding-left: 0;
            padding-right: 0;
        }

    }

</style>


// WEBPACK FOOTER //
// src/Components/TwoTextFieldsWithSymbols.vue